
import axios from "axios";
import { URL_BASE } from "../config/url-server";
const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")



export const getListByRol = async (role) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const url = `${URL_BASE}user/list-by-rol?role=${role}`
    const response = await axios.get(url, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const getUser = async (userId) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.get(URL_BASE + "user/get/" + userId, config)
    const user = response.data?.data || null;
    return user;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const getList = async (findName) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const url = `${URL_BASE}user/list?name=${findName}`
    const response = await axios.get(url, config);
    const listado = response.data?.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};





export const getListUsers = async (page,limit,findName) => {
  const params = {page,limit,findName};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "user/list",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const insert = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "user/insert", data, config)
    const success = response?.data || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};


export const update = async (data) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
  try {
    const response = await axios.post(URL_BASE + "user/update", data, config)
    const success = response.data?.success || null;
    return success;
  } catch (error) {
    console.error("Error:", error);
    return false;
  }
};



export const list = async (page, limit, findName) => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}user/list?page=${page}&limit=${limit}&name=${findName}`
    const response = await axios.get(url, config)
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const listAll = async () => {
  try {
    const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` } };
    const url = `${URL_BASE}user/list-all`
    const response = await axios.get(url, config)
    const listado = response.data.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export const listInAccumulation = async (startDate, endDate, farmId, sectionId, lotId) => {
  const params = { startDate, endDate, farmId, lotId, sectionId };
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };
  try {
    const response = await axios.get(
      URL_BASE + "user/list-in-accumulations",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};




export const listInSupervision = async (startDate, endDate, farmId, sectionId, lotId) => {
  const params = { startDate, endDate, farmId, lotId, sectionId };
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };
  try {
    const response = await axios.get(
      URL_BASE + "user/list-in-supervision",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};


export const listUsersYieldAccumulation = async (params) => {
  const config = { headers: { client: clientId, Authorization: `Bearer ${accessToken}` }, params };
  try {
    const response = await axios.get(
      URL_BASE + "user/list-in-yield-accumulations",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};



export default {
  getListUsers,
  list,
  getUser,
  getList,
  insert,
  update,
  listAll,
  getListByRol,
  listInAccumulation,
  listInSupervision,
  listUsersYieldAccumulation
}

